import { render, staticRenderFns } from "./pending_review.vue?vue&type=template&id=df9c9e9c&scoped=true&"
import script from "./pending_review.vue?vue&type=script&lang=js&"
export * from "./pending_review.vue?vue&type=script&lang=js&"
import style0 from "./pending_review.vue?vue&type=style&index=0&id=df9c9e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9c9e9c",
  null
  
)

export default component.exports